export default __webpack_public_path__ + "static/media/Pendant of Preservation.4dda1893.jpg";